<div class="stu-spaces-list-page">
  <div class="pre-page spen-mod-heading lv-1">
    <h1 class="heading-text">
      <button class="spen-mod-btn is-primary" (click)="slideMenu()"><i class="fa fa-reorder"></i></button>スペース
    </h1>
  </div>
  <div class="block-content">
    <a class="spen-mod-btn is-primary" (click)="sendNewDocumentGAEvent()" routerLink="/documents/new">活動記録作成</a>
    <div class="spaces-list">
      @if (dataLoaded) {
        @if (spacesCount > 0) {
          <div class="spaces">
            @for (space of spaces; track space.id) {
              <a class="space-element" [routerLink]="['/spaces/student/', space.id]">
                <div class="space" [style.background-color]="space.color_code">
                  <div class="list-icons">
                    <img src="/assets/images/icon_space.svg" />
                  </div>
                  <span class="space-name">{{ space.name | trimText: 27 }}</span>
                </div>
              </a>
            }
          </div>
          @if (showPagination) {
            <div class="pagination">
              <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
            </div>
          }
        } @else {
          <div class="empty-content">
            <p class="text">参加しているスペースが表示されます。</p>
          </div>
        }
      } @else {
        <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
      }
    </div>
  </div>
  <div class="block-footer">
    @if (!isMobileApp) {
      <a href="{{ classiUrl }}" class="spen-mod-btn is-default">ホームへ戻る</a>
    }
  </div>
</div>
